<label class="relative flex items-center cursor-pointer">
  <input
    class="sr-only peer"
    type="checkbox"
    [ngModel]="checked"
    (ngModelChange)="onNgModelChange($event)"
    [disabled]="disabled"
    [attr.tabindex]="disabled ? -1 : tabIndex === null ? null : tabIndex"
  />
  <div
    [ngClass]="{'opacity-60 after:bg-gray-400': disabled, 'after:bg-white': !disabled}"
    class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue2"></div>
  <span
    class="ml-3 font-medium text-gray-900 {{labelClass}}">{{checked ? checkedLabel || ('on' | transloco) : uncheckedLabel || ('off' | transloco)}}</span>
</label>
